import { render, staticRenderFns } from "./UserIconDefault.vue?vue&type=template&id=dfcf6fec&"
import script from "./UserIconDefault.vue?vue&type=script&lang=js&"
export * from "./UserIconDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports